import { FreeMode, Navigation, Pagination } from 'swiper/modules';

export const swiperConfig = {
  modules: [FreeMode, Navigation, Pagination],
  freeMode: false,
  navigation: true,
  pagination: {
    dynamicBullets: true,
    clickable: true,
  },

  slidesPerView: 2,

  spaceBetween: 10,

  breakpoints: {
    640: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 16,
    },
    768: {
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 16,
    },
    1024: {
      slidesPerView: 4,
      slidesPerGroup: 4,
      spaceBetween: 20,
    },
    1280: {
      slidesPerView: 4,
      slidesPerGroup: 4,
      spaceBetween: 20,
    },
    1366: {
      slidesPerView: 4,
      slidesPerGroup: 4,
      spaceBetween: 20,
    },
    1440: {
      slidesPerView: 4,
      slidesPerGroup: 4,
      spaceBetween: 24,
    },
  },
};
